module.exports = __webpack_public_path__ + "img/card-bg5.6af84338.png";